import UiSelectOption from "./UiSelectOption";

/**
 * 业务发生日
 * @description 自动生成的代码,请勿修改
 */
export enum EnumBusinessDate {
    /**
     * ETD
     */
    ETD = 0,
    /**
     * ATD
     */
    ATD = 1,
    /**
     * ETA
     */
    ETA = 2,
    /**
     * ATA
     */
    ATA = 3,
    /**
     * 手动调整
     */
    Default = 999,
}

/**
 * 业务发生日-选项
 */
export const EnumBusinessDateOption: UiSelectOption<number>[] = [
    { Label: "ETD", Value: 0, Data: "ETD" },
    { Label: "ATD", Value: 1, Data: "ATD" },
    { Label: "ETA", Value: 2, Data: "ETA" },
    { Label: "ATA", Value: 3, Data: "ATA" },
    { Label: "手动调整", Value: 999, Data: "Default" },
];
